import { com } from '@eidu/web'
import NextOption from '../../../components/input/NextOption'
import Item = com.eidu.sharedlib.form.definition.Item
import Checkbox = com.eidu.sharedlib.form.definition.Checkbox
import SingleLine = com.eidu.sharedlib.form.definition.SingleLine
import MultiLine = com.eidu.sharedlib.form.definition.MultiLine
import Date = com.eidu.sharedlib.form.definition.Date
import EntityChoice = com.eidu.sharedlib.form.definition.EntityChoice
import Location = com.eidu.sharedlib.form.definition.Location
import MultiAnswer = com.eidu.sharedlib.form.definition.MultiAnswer
import SingleChoice = com.eidu.sharedlib.form.definition.SingleChoice
import MultipleChoice = com.eidu.sharedlib.form.definition.MultipleChoice
import Section = com.eidu.sharedlib.form.definition.Section
import GradeDropDown = com.eidu.sharedlib.form.definition.GradeDropDown
import SchoolDropDown = com.eidu.sharedlib.form.definition.SchoolDropDown
import StreamDropDown = com.eidu.sharedlib.form.definition.StreamDropDown
import UserDropDown = com.eidu.sharedlib.form.definition.UserDropDown
import Description = com.eidu.sharedlib.form.definition.Description

const localNextItemFromItem = (item: Item): NextOption | undefined => {
  if (item instanceof Description) {
    return undefined
  } else if (item instanceof Checkbox) {
    return { next: { key: item.key, type: 'item' }, label: item.prompt }
  } else if (item instanceof SingleLine) {
    return { next: { key: item.key, type: 'item' }, label: item.prompt }
  } else if (item instanceof MultiLine) {
    return { next: { key: item.key, type: 'item' }, label: item.prompt }
  } else if (item instanceof Date) {
    return { next: { key: item.key, type: 'item' }, label: item.prompt }
  } else if (item instanceof Location) {
    return { next: { key: item.key, type: 'item' }, label: item.prompt }
  } else if (item instanceof EntityChoice) {
    return { next: { key: item.key, type: 'item' }, label: item.prompt }
  } else if (item instanceof MultiAnswer) {
    return { next: { key: item.key, type: 'item' }, label: item.prompt }
  } else if (item instanceof SingleChoice) {
    return { next: { key: item.key, type: 'item' }, label: item.prompt }
  } else if (item instanceof MultipleChoice) {
    return { next: { key: item.key, type: 'item' }, label: item.prompt }
  } else if (item instanceof Section) {
    return { next: { key: item.key, type: 'item' }, label: item.title }
  } else if (item instanceof GradeDropDown) {
    return undefined
  } else if (item instanceof SchoolDropDown) {
    return undefined
  } else if (item instanceof StreamDropDown) {
    return undefined
  } else if (item instanceof UserDropDown) {
    return undefined
  }
}

export default localNextItemFromItem
